var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(_vm._s(_vm.$t('common.ks2-package'))+":"),_c('strong',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.review.Reviewer.ReviewedEntity.Code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }